import { Breadcrumb, Card, Col, Layout, Row, Typography } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import { MenuComponent } from '../../../../shared/menu-component';
import { CaseDetailsContainer } from './components/case-details.container';
import { ChangeStatusContainer } from './components/change-status.container';
import { DecisionDetailContainer } from '../archive/components/decision-detail.container';
import { CollapsibleApplicantProfileContainer } from './components/collapsible-applicant-profile.container';
import  { ChecklistContainer } from './components/checklist.container';
import { RelatedCasesTabContainer } from './components/related-cases-tab.container';
import { CaseInfoHeaderContainer } from './components/case-info-header.container';


const { Title } = Typography;
interface SendReportLayoutProps {
  pageLayouts: any[];
  caseState: string;
  caseId: string;
  caseName?: string;
  isApplicantSection?: boolean;
}
export const SendReportLayout: React.FC<SendReportLayoutProps> = (props) => {
  const isDecisionRendered = props.caseState === 'decisionRendered';
  const navigate = useNavigate();

  return (
    <Layout style={{ padding: '24px' }}>
      <div>
        <Breadcrumb
          className="text-sm"
          separator="/"
          items={[
            {
              title: (
                <button
                  onClick={() => navigate(-1)}
                  aria-label="Go back to Cases"
                  className="bg-transparent border-none p-0 cursor-pointer outline-none focus:outline-none active:bg-transparent hover:bg-transparent"
                >
                   {props.isApplicantSection ? 'Applicants' : 'Cases'}
                </button>
              )
            },
            { title: 'Send Report' }
          ]}
        />
      </div>
      {/* Header Section */}
      <Card style={{ background: 'transparent', border: 'none' }}>
        <div>
          <div id="leftTitle" style={{ display: 'inline', float: 'left' }}>
            <Title level={3} style={{ display: 'inline' }}>
              {props.caseName}
            </Title>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Title level={4} type="secondary" style={{ display: 'inline' }}>
              Send Report
            </Title>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div id="rightButton" style={{ float: 'right', marginTop: '-30px' }}>
            <ChangeStatusContainer caseId={props.caseId ?? ''} />
          </div>
        </div>
        <div style={{ clear: 'both' }}></div>
        <CaseInfoHeaderContainer caseId={props.caseId ?? ''} />
        {isDecisionRendered && <DecisionDetailContainer caseId={props.caseId ?? ''} />}
      </Card>

      <Row gutter={16}>
        <Col span={16}>
          <Card hoverable style={{ marginBottom: '20px' }}>
            <CaseDetailsContainer caseId={props.caseId ?? ''} />
          </Card>
          <div style={{ marginBottom: '20px' }}>
            <CollapsibleApplicantProfileContainer caseId={props.caseId ?? ''} />
          </div>
          {/* Tabs Section */}
          <div>
            <MenuComponent isReplacingCurrentRoute={true} pageLayouts={props.pageLayouts} theme="light" mode="horizontal" />
            <Outlet />
          </div>
        </Col>

        <Col span={8}>
          {/* Related Cases and Status */}
          <Card hoverable style={{ marginBottom: '20px' }}>
            <RelatedCasesTabContainer caseId={props.caseId ?? ''} isArchived={false} />
          </Card>

          {/* Checklist Section */}

          <Card hoverable>
            <ChecklistContainer caseId={props.caseId ?? ''} />
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};
